/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignableAssetResponseDto
 */
export interface AssignableAssetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssignableAssetResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableAssetResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableAssetResponseDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableAssetResponseDto
     */
    zoneName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignableAssetResponseDto
     */
    siteName: string;
}

/**
 * Check if a given object implements the AssignableAssetResponseDto interface.
 */
export function instanceOfAssignableAssetResponseDto(value: object): value is AssignableAssetResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('siteName' in value) || value['siteName'] === undefined) return false;
    return true;
}

export function AssignableAssetResponseDtoFromJSON(json: any): AssignableAssetResponseDto {
    return AssignableAssetResponseDtoFromJSONTyped(json, false);
}

export function AssignableAssetResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignableAssetResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'serialNumber': json['serialNumber'],
        'zoneName': json['zoneName'] == null ? undefined : json['zoneName'],
        'siteName': json['siteName'],
    };
}

export function AssignableAssetResponseDtoToJSON(json: any): AssignableAssetResponseDto {
    return AssignableAssetResponseDtoToJSONTyped(json, false);
}

export function AssignableAssetResponseDtoToJSONTyped(value?: AssignableAssetResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'serialNumber': value['serialNumber'],
        'zoneName': value['zoneName'],
        'siteName': value['siteName'],
    };
}

